export const STATUS_LABELS = {
  // document status
  draft: "In Draft", submitted: "Submitted", closed: "Closed",
  // reviewed_by
  pending: "Pending", admin: "Admin", advocate: "Advocate",
  // payment_status
  completed: "Completed", failed: "Failed", unpaid: "Unpaid", refunded: "Refunded",
  // delivery_status (industry-standard courier lifecycle, ready for a delivery-partner API)
  not_started: "Not Started", dispatched: "Dispatched", delivered: "Delivered",
  // softcopy_status
  not_generated: "Not Generated", available: "Available", waived: "Waived",
  // legacy values (pre-existing records)
  open: "Open", wip: "Work In Progress", delayed: "Delayed", paid: "Paid",
  // admin_stage (core.lifecycle.compute_admin_stage — derived, not a tracked field)
  unassigned: "Unassigned", under_review: "Under Review", cancelled: "Cancelled",
  ready_to_issue: "Ready to Issue", ready_to_dispatch: "Ready to Dispatch",
  in_delivery: "In Delivery", delivery_failed: "Delivery Failed",
  customer_info_missing: "Customer Info Missing",
  ready_to_complete: "Ready to Complete", completed: "Completed",
  // review_status
  not_started: "Not Started", in_progress: "In Progress", accepted: "Accepted",
  // draft state (derived in CustomerDashboard's draftState — the one thing an unpaid case is
  // waiting on, not a tracked field, same as admin_stage above)
  details_missing: "Details Missing", ready: "Ready",
};

// Some raw values mean something different depending on which field they came from —
// "pending" alone reads as vague, so disambiguate per-dimension (pass `dim`).
const DIM_OVERRIDES = {
  status: { pending: "Payment Pending" },
  reviewed_by: { pending: "Unassigned" },
  review_status: { submitted: "Awaiting Acceptance" },
};

export const pillLabel = (status, dim) => {
  const s = (status || "pending").toLowerCase();
  return DIM_OVERRIDES[dim]?.[s] || STATUS_LABELS[s] || s;
};

export const StatusPill = ({ status, dim }) => {
  const s = (status || "pending").toLowerCase();
  return <span data-testid={`status-pill-${s}`} className={`pill pill-${s}`}>{pillLabel(status, dim)}</span>;
};
